import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RadarEdicaoPage } from './radar-edicao.page';

const routes: Routes = [
  {
    path: '',
    component: RadarEdicaoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RadarEdicaoPageRoutingModule {}
